var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.5001C21.5 15.8762 16.8309 20.2904 11 20.2904C5.16908 20.2904 0.5 15.8762 0.5 10.5001C0.5 5.12391 5.16908 0.709747 11 0.709747C16.8309 0.709747 21.5 5.12391 21.5 10.5001Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.515 15.2097V5.78975H10.8C11.875 5.78975 12.6875 6.04725 13.2375 6.56225C13.7925 7.07225 14.07 7.74475 14.07 8.57975C14.07 9.40475 13.7925 10.0747 13.2375 10.5897C12.6875 11.0997 11.875 11.3547 10.8 11.3547H8.685V15.2097H7.515ZM12.795 15.2097L10.095 10.9347H11.37L14.31 15.2097H12.795ZM8.685 10.5297H10.71C11.415 10.5297 11.95 10.3572 12.315 10.0122C12.685 9.66225 12.87 9.20975 12.87 8.65475C12.87 8.08475 12.6925 7.63225 12.3375 7.29725C11.9875 6.96225 11.475 6.79475 10.8 6.79475H8.685V10.5297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.b630e70bd2c5b44da25f5171b5e02cae.svg";
export { ForwardRef as ReactComponent };